import { Injectable, Pipe, PipeTransform } from '@angular/core';

import { Day } from '../../../shared/models/day.type';
import { DateService } from '../../../shared/services/date.service';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'isMoreDays',
  standalone: true,
})
export class IsMoreDaysPipe implements PipeTransform {
  constructor(private dateService: DateService) {}

  transform(value?: Date, origin?: Day, days?: number): boolean {
    if (!value || !origin) {
      return false;
    }

    return (
      value.getTime() >
      this.dateService
        .addDaysToDate(this.dateService.yyyymmddToDate(origin), days || 0)
        .getTime()
    );
  }
}
